import { render, staticRenderFns } from "./QScoreCardPieChart.vue?vue&type=template&id=34de9e01&scoped=true&"
import script from "./QScoreCardPieChart.vue?vue&type=script&lang=js&"
export * from "./QScoreCardPieChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34de9e01",
  null
  
)

export default component.exports